import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-asset-health-box',
  templateUrl: './asset-health-box.component.html',
  styleUrls: ['./asset-health-box.component.scss'],
  standalone: true,
  encapsulation:ViewEncapsulation.None
})
export class AssetHealthBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
